@import '~style-sheet-helpers/core.less';

.print-modal-header {
  display: flex;
  justify-content: space-between;
  height: 100%;
  align-items: center;
}

.close-button {
  width: 40px;
  height: 40px;
  > button {
    .vertical-align();
  }
}
